import React from 'react';
import { Skeleton } from '@c2fo/react-components';

export const SummaryCardSkeleton: React.FC = (props) => (
  <Skeleton data-testid={'summary-card-skeleton'} variant={'rect'} height={275} />
);
